(function () {
  "use strict";

  SeriesManageCtrl.$inject = ['$scope', '$route', 'gridFormatters', 'arrangeResource', 'mtypes', '$rootScope', 'textLengthIndicatorState', 'Validation', '$location', 'accountFeatures', '$window', 'seriesTypeModel', 'actionLogResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('SeriesManageCtrl', SeriesManageCtrl);

  function SeriesManageCtrl($scope, $route, gridFormatters, arrangeResource, mtypes, $rootScope, textLengthIndicatorState,
                            Validation, $location, accountFeatures, $window, seriesTypeModel, actionLogResource) {

    var detailFormFieldValidityCache = {};
    var detailFormAllTextLengthKeys = {
      trainerName: 60,
      trainerEmail: 254,
      seriesTitle: 70,
      seriesDescription: 400
    };
    var requiredKeys = ['trainerName', 'trainerEmail'];
    var traineesInSeries = false;

    $scope.hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);

    $scope.seriesOptions = seriesTypeModel;

    $scope.seriesSequenceChanged = $scope.hasNewSeriesFeature ? seriesSequenceChanged : seriesOptionsChanged;

    $scope.seriesCourseFailureChanged = function() {
      if($scope.seriesOptions.courseFailureEnforced)
        $scope.seriesOptions.sequenceEnforced = true;

      $scope.coursesFormDirty = calcCoursesFormDirty();
    };

    function seriesSequenceChanged() {
      if(!$scope.seriesOptions.sequenceEnforced)
        $scope.seriesOptions.courseFailureEnforced = false;

      seriesOptionsChanged();
    }

    function seriesOptionsChanged() {
      $scope.coursesFormDirty = calcCoursesFormDirty();
    }

    function recalcDetailFormTextLengthIndicators() {
      for (var key in detailFormAllTextLengthKeys) {
        _validateDetailFormTextLength(key);
      }
      $scope.detailForm.valid = calcDetailFormValidity();
    }

    $scope.onDetailFormFieldInputBlur = function (key) {
      // leave errors
      var state = detailFormFieldValidityCache[key];
      if (!state.lengthValid || !state.dataValid)
        return;
      state = textLengthIndicatorState.defaultState;
      applyDetailsFormState(key, state);
    };

    var emailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

    function _validateDetailFormTextLength(key) {
      var text = $scope[key];
      var state = textLengthIndicatorState.getState(text, detailFormAllTextLengthKeys[key]);

      if (~requiredKeys.indexOf(key) && (!text || !text.trim().length)) {
        state.dataValid = false;
      } else if (key === 'trainerEmail') {
        state.dataValid = state.lengthValid && emailRegex.test($scope[key]);
        $scope.trainerEmailStyle = state.dataValid ? '' : 'redBorder';
      }

      applyDetailsFormState(key, state);
      detailFormFieldValidityCache[key] = state;
    }

    $scope.validateDetailFormTextLength = function (key) {
      _validateDetailFormTextLength(key);
      $scope.detailForm.valid = calcDetailFormValidity();
      $scope.detailForm.dirty = calcDetailFormDirty();
    };

    $scope.onDetailFormFieldFocus = function (key) {
      applyDetailsFormState(key, detailFormFieldValidityCache[key]);
    };

    function applyDetailsFormState(key, state) {
      $scope[key + 'IndicatorStyle'] = state.style;
      $scope[key + 'IndicatorText'] = state.text;
      $scope[key + 'Style'] = state.dataValid ? '' : 'redBorder';
    }

    function calcDetailFormValidity() {
      for (var key in detailFormFieldValidityCache) {
        if (!detailFormFieldValidityCache[key].lengthValid || !detailFormFieldValidityCache[key].dataValid)
          return false;
      }
      return true;
    }

    function calcDetailFormDirty() {
      for (var key in detailFormFieldValidityCache) {
        if ($scope[key] && $scope[key].trim() != $scope.currentDetail[key])
          return true;
      }
      return false;
    }

    $scope.detailForm = {
      valid: true,
      dirty: false
    };

    $scope.checkSeriesCourse = function () {
      $scope.emptySeries = $scope.seriesCourses.length <= 0;
    };

    $scope.resetSeriesCourses = function () {
      $scope.courses = _.sortBy(_.map($scope.currentCourses, function (course) {
        var status = gridFormatters.mtypeFormatter(null, null, course.status);
        return {
          id: course.id,
          name: course.name,
          modified: gridFormatters.dateFormatter(null, null, course.modified),
          modifiedSort: course.modifiedSort,
          status: status,
          itemStyle: (status || '').toLowerCase() == 'active' ? 'active-course' : 'disabled',
          type: 'course',
          tips: (status || '').toLowerCase() == 'active' ? '' : 'Only Active courses can be added to a series'
        }
      }), function (course) {
        return course.name;
      });

      $scope.seriesCourses = _.map($scope.currentSeriesCourses, function (course) {
        return {
          id: course.courseId,
          name: course.courseName,
          modified: gridFormatters.dateFormatter(null, null, course.modified),
          modifiedSort: course.modifiedSort,
          status: gridFormatters.mtypeFormatter(null, null, course.status),
          type: 'seriesCourse'
        }
      });

      $scope.seriesOptions.reset();
      $scope.coursesFormDirty = false;
      $scope.checkSeriesCourse();
    };

    $scope.resetSeriesInfo = function () {
      if (!$scope.currentDetail) return;
      if (!$scope.currentDetail.seriesDescription) {
        $scope.currentDetail.seriesDescription = '';
      }

      $scope.trainerName = $scope.currentDetail.trainerName;
      $scope.trainerEmail = $scope.currentDetail.trainerEmail;
      $scope.seriesDescription = $scope.currentDetail.seriesDescription;

      if ($scope.currentDetail.seriesTitle)
        $scope.seriesTitle = $scope.currentDetail.seriesTitle == "Untitled Series" ? "" : $scope.currentDetail.seriesTitle;

      $scope.detailForm.valid = false;
      $scope.detailForm.dirty = false;

      textLengthIndicatorState.resetStates();

      recalcDetailFormTextLengthIndicators();
    };

    function filterSampleCourse(courses) {
      if (!~accountFeatures.features.indexOf(mtypes.featureEntry.trainerHTMLHome)) {
        return _.filter(courses, function (item) {
          return item.id != mfConfig.sampleCourseId;
        });
      }

      return courses;
    }

    function setup() {
      $scope.dragProxyItem = null;
      $scope.showSeriesDropPosition = false;
      $scope.currentCourses = filterSampleCourse($scope.resolvedData.courses);

      $scope.currentSeriesCourses = $scope.resolvedData.seriesCourses;
      $scope.currentDetail = $scope.resolvedData.seriesDetail;
      $scope.seriesTitle = $scope.currentDetail.seriesTitle == "Untitled Series" ? "" : $scope.currentDetail.seriesTitle;
      traineesInSeries = $scope.currentDetail.traineesInSeries;

      $scope.resolvedData = null;

      $scope.seriesOptions.init($scope.currentDetail.seriesType);
      $scope.resetSeriesCourses();
      $scope.resetSeriesInfo();
    }

    setup();

    $scope.courseDragStart = function (dragItem) {
      $scope.dragProxyItem = dragItem;
    };

    $scope.courseDragDrop = function (dragData) {
      var _seriesCourses = $scope.seriesCourses.concat();
      var _courses = $scope.courses.concat();
      var courseListChnaged = false;

      if (dragData.from.type == 'seriesCourse'
          // removing a course from the series: dragging from series list to course list (right to left)
        && (dragData.to.type == 'course' || dragData.to.type == 'courseList')) {

        courseListChnaged = true;
        var seriesCourse = _.find(_seriesCourses, function (c) {
          return c.id == dragData.from.courseId;
        });
        var seriesIndex = _seriesCourses.indexOf(seriesCourse);

        _seriesCourses.splice(seriesIndex, 1);

        _courses.push(cloneSeriesCourseToCourse(seriesCourse));

      } else if (dragData.to.type == 'seriesCourse' || dragData.to.type == 'seriesList' || dragData.to.type == 'seriesListTop') {
        var newItem;
        courseListChnaged = true;

        // adding a course to the series : dragging from the course list
        if (dragData.from.type == 'course') {
          courseListChnaged = true;
          var course = _.find(_courses, function (c) {
            return c.id == dragData.from.courseId;
          });
          var courseIndex = _courses.indexOf(course);

          _courses.splice(courseIndex, 1);

          newItem = cloneCourseToSeriesCourse(course);
        } else {
          // dragging from a series list
          var seriesCourse = _.find(_seriesCourses, function (c) {
            return c.id == dragData.from.courseId;
          });
          var oldItemIndex = _seriesCourses.indexOf(seriesCourse);

          _seriesCourses.splice(oldItemIndex, 1);

          newItem = seriesCourse;
        }

        // drag to series list
        if (dragData.to.courseId) {
          var toSeriesCourse = _.find(_seriesCourses, function (c) {
            return c.id == dragData.to.courseId;
          });
          var itemIndex = _seriesCourses.indexOf(toSeriesCourse);

          if (dragData.to.insertPosition == 'before') {
            _seriesCourses.splice(itemIndex, 0, newItem);
          } else {
            // check if you are dragging the course list
            if (courseIndex > -1) {
              _seriesCourses.splice(itemIndex + 1, 0, newItem);
            } else {
              if (itemIndex + 1 > oldItemIndex) {
                _seriesCourses.splice(itemIndex + 1, 0, newItem);
              } else {
                _seriesCourses.splice(itemIndex, 0, newItem);
              }
            }
          }
        } else {
          // dragging to the top of the series list
          if (dragData.to.insertPosition == 'before') {
            _seriesCourses.splice(0, 0, newItem);
          } else {
            // dragging to the bottom of the series list
            _seriesCourses.push(newItem);
          }
        }
      } else {
        return;
      }

      $scope.seriesCourses = _seriesCourses;

      if (courseListChnaged) {
        $scope.courses = _courses;
      }

      $scope.coursesFormDirty = calcCoursesFormDirty();
      $scope.checkSeriesCourse();
    };

    function calcCoursesFormDirty() {
      // if series-type changed
      if ($scope.seriesOptions.isDirty())
        return true;

      // if a course was added or removed
      if ($scope.seriesCourses.length != $scope.currentSeriesCourses.length)
        return true;

      // if courses differ or are in a new order
      for (var i = 0; i < $scope.seriesCourses.length; i++) {
        if ($scope.seriesCourses[i].id != $scope.currentSeriesCourses[i].courseId)
          return true;
      }

      return false;
    }

    function cloneSeriesCourseToCourse(seriesCourse) {
      return {
        id: seriesCourse.id,
        name: seriesCourse.name,
        modified: seriesCourse.modified,
        modifiedSort: seriesCourse.modifiedSort,
        status: seriesCourse.status,
        itemStyle: (seriesCourse.status || '').toLowerCase() == 'active' ? 'active-course' : 'disabled',
        type: 'course'
      }
    }

    function cloneCourseToSeriesCourse(course) {
      return {
        id: course.id,
        name: course.name,
        modified: course.modified,
        modifiedSort: course.modifiedSort,
        status: course.status,
        type: 'seriesCourse'
      }
    }

    $scope.updateSeriesInfo = function () {
      arrangeResource.updateSeriesDetails({
        seriesId: $route.current.params.seriesId,
        trainerName: $scope.trainerName,
        trainerEmail: $scope.trainerEmail,
        seriesDescription: $scope.seriesDescription,
        seriesTitle: $scope.seriesTitle || "Untitled Series",
        seriesType: $scope.seriesOptions.save()
      }, function () {
        var title = $scope.seriesTitle || "Untitled Series";
        $rootScope.title.seriesTitle = title;
        $scope.detailForm.valid = false;
        $scope.detailForm.dirty = false;

        $scope.currentDetail = {
          seriesDescription: $scope.seriesDescription,
          trainerName: $scope.trainerName,
          trainerEmail: $scope.trainerEmail,
          seriesTitle: title,
          traineesInSeries: traineesInSeries
        };

        recalcDetailFormTextLengthIndicators();
      }, function (err) {
      });
    };

    $scope.updateSeriesCoursesPending = false;

    $scope.updateSeriesCourses = function () {
      $scope.coursesFormDirty = false;
      $scope.updateSeriesCoursesPending = true;
      var updateInfo = {
        seriesId: $route.current.params.seriesId,
        seriesType: $scope.seriesOptions.save(),
        courseIds: []
      };

      _.each($scope.seriesCourses, function (course) {
        updateInfo.courseIds.push(course.id);
      });

      arrangeResource.updateSeriesCourses(updateInfo, function () {
        $scope.updateSeriesCoursesPending = false;
        // refresh series courses
        arrangeResource.getSeriesInfo($route.current.params.seriesId, function (res) {
          $scope.currentCourses = res.courses;
          $scope.currentSeriesCourses = res.seriesCourses;
          $scope.currentDetail.seriesType = res.seriesDetail.seriesType;
        });
      }, function (err) {
        $scope.updateSeriesCoursesPending = false;
        $scope.resetSeriesCourses();
      });

      if(_.isEmpty(updateInfo.courseIds) || updateInfo.seriesType != mtypes.seriesType.courseFailureEnforced)
        return;

      // save actionlog
      var actionLog = {
        action: mtypes.actionType.seriesCourseRearranged,
        primaryEntityId: updateInfo.seriesId,
        primaryEntityType: mtypes.entityType.series,
        metadata1: _.pluck($scope.currentSeriesCourses, 'courseId').join(),
        metadata2: updateInfo.courseIds.join()
      };

      actionLogResource.writeActionLog([actionLog], angular.noop, angular.noop);
    };

    $scope.sortArrow = {
      name: '',
      modified: '',
      status: ''
    };

    var sortByColumn = 'name';

    $scope.sortBy = function (value) {
      $scope.sortArrow[sortByColumn] = '';
      if (sortByColumn == value)
        $scope.reverse = !$scope.reverse;

      $scope.sortArrow[value] = "slick-sort-indicator-" + ($scope.reverse ? "asc" : "desc");
      sortByColumn = value;
    };

    $scope.getSortByColumnValue = function (item) {
      return item[sortByColumn];
    };

    $scope.getCourse = function (id) {
      var course = _.find($scope.seriesCourses, function (c) {
        return c.id == id;
      });
      if (course)
        return course;

      return _.find($scope.courses, function (c) {
        return c.id == id;
      });
    };


    function editorsDirty() {
      return $scope.detailForm.dirty || $scope.coursesFormDirty;
    }

    Validation.addValidation(validate);

    var nextLocation;

    function validate() {
      if (!editorsDirty())
        return true;

      nextLocation = $rootScope.newLocation.next;
      $scope.$broadcast('showUnsavedChanges');
      return false;
    }

    $scope.$on('unsavedChangesLeave', function () {
      Validation.removeValidation(validate);
      setTimeout(function () {
        $location.path(nextLocation.path).search(nextLocation.search);
        $rootScope.$apply();
      }, 100)
    });

    $scope.$on('$destroy', function () {
      Validation.removeValidation(validate);
    });

    $scope.$on('appOnBeforeUnload', function (e, customWarnings) {
      if (editorsDirty())
        e.preventDefault();
    });
  }

})();
